// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quantities-grid input {\n  text-align: center;\n}\n.quantity-summary input.input[readonly] {\n  background: #fff !important;\n}\n.quantity-summary input.input[disabled] {\n  background: #eee !important;\n}\n", ""]);
// Exports
module.exports = exports;
